import {fetch} from 'whatwg-fetch';
import {AppError} from '../core/AppError';
import moment from 'moment';
import {isNumeric} from '../helpers/functionsHelper';
import StorageDataService from './StorageDataService';
import {Mutex} from 'async-mutex';

const mutex = new Mutex();

class UserTokenService {

    constructor() {
        this.storageDataService = new StorageDataService({
            fieldName: 'filemanager_token',
            storageType: 'localStorage',
        });
    }

    async getTokenFromVikon() {
        const options = {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
            },
        };
        const response = await fetch('/oauth2/tokenToFilemanager', options);
        if (response.ok) {
            return response.json();
        }
        throw new AppError('Не удалось получить токен с сервера');
    }

    setToken(token) {
        this.storageDataService.save({
            token: token.access_token,
            expires: token.expires,
        });
    }

    async getToken() {
        const release = await mutex.acquire();
        try {
            const filemanagerToken = this.storageDataService.get();
            if (!filemanagerToken) {
                const tokenFromServer = await this.getTokenFromVikon();
                this.setToken(tokenFromServer);
                return tokenFromServer.access_token;
            }
            const {token, expires} = filemanagerToken;
            const dateFormat = 'YYYY-MM-DD HH:mm:ss';
            const currentDate = moment().add(20, 'seconds').format(dateFormat);

            if (!token || token.length < 20 || isNumeric(expires) || moment(currentDate).isAfter(moment(expires))) {
                const tokenFromServer = await this.getTokenFromVikon();
                this.setToken(tokenFromServer);
                return tokenFromServer.access_token;
            }
            return token;
        } finally {
            release();
        }
    }

    async clearToken() {
        const release = await mutex.acquire();
        try {
            this.storageDataService.delete();
        } finally {
            release();
        }
    }
}

export default UserTokenService;
